<div class="wrapper">
    <div class="left-column">
      <div i18n="@@UkupnoBezPdv">Ukupno bez PDV: </div>
      <div i18n="@@DostavaBezPdv">Dostava bez PDV </div>
      <div *ngFor="let taxItem of resource?.taxPerRate">{{taxItem.taxRate.name}} </div>
      <div i18n="@@Ukupno" class="total">Ukupno: </div>
    </div>
    <div class="right-column">
      <div>{{resource?.subTotal.amount}} {{resource?.subTotal.currency | lowercase}}</div>
      <div *ngFor="let taxItem of resource?.taxPerRate">
        {{taxItem?.amount | number : '1.2-2'}} {{taxItem?.currency | lowercase}}</div>
      <div class="total">{{resource?.total.amount}} {{resource?.total.currency | lowercase}} </div>
    </div>
  </div>